type UnknownRecord = Record<string, unknown>;

function isRecord(value: unknown): value is UnknownRecord {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function migrateNode(value: unknown): unknown {
  if (!isRecord(value)) return value;
  return {
    ...value,
    locationIds: Array.isArray(value.locationIds) ? value.locationIds : [],
  };
}

function migrateEdge(value: unknown): unknown {
  if (!isRecord(value)) return value;
  const strength = String(value.strength);
  return {
    ...value,
    failureEffect: value.failureEffect ?? (strength === 'hard' ? 'unavailable' : strength === 'degraded' ? 'degraded' : 'none'),
    propagationDelayMinutes: value.propagationDelayMinutes ?? 0,
    evidenceIds: Array.isArray(value.evidenceIds) ? value.evidenceIds : [],
  };
}

/** Upgrade a legacy payload without inventing recovery targets or evidence. */
export function migrateWorkspace(value: unknown): unknown {
  if (!isRecord(value) || value.format !== 'inventivehq.dependency-atlas') return value;
  if (value.version !== 1 && value.version !== 2) return value;

  return {
    ...value,
    version: 2,
    nodes: Array.isArray(value.nodes) ? value.nodes.map(migrateNode) : value.nodes,
    edges: Array.isArray(value.edges) ? value.edges.map(migrateEdge) : value.edges,
    fallbackProfiles: Array.isArray(value.fallbackProfiles) ? value.fallbackProfiles : [],
  };
}
